module.exports = __webpack_public_path__ + "img/super-rare-badge.10992b0d.png";